import React from 'react';
import { Container } from 'react-bootstrap';
import "../App.css";
import { FaWhatsapp, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';

const Footer = () => (
  <div className="footer text-white pt-5">
    <Container>
      <div className="row">
        {/* Left Column */}
        <div className="col-md-6 mb-4">
          <h3 className="footer-title">Valerion Impex Pvt Ltd</h3>
          <p className="mb-1"><strong>Address:</strong></p>
          <p className="footer-text">
            2nd Floor, Office No. 4A, K.K Chambers, Purshotamdas Thakurdas Road,
            <br />
            <span className="ms-4">Near Siddharth College, Fort, Mumbai 400001, India</span>
          </p>

          <h5 className="mt-4">Contact</h5>
          <p className="footer-text">
            <strong>Tel:</strong> +91 22 22016014 / 15<br />
            <strong>Mobile:</strong> +91 9820334961 / 98196 64898<br />
            <strong>Email:</strong> valerionimpexcement@gmail.com<br />
            <strong>Email:</strong> valerionimpex@gmail.com

            
          </p>
        </div>

        {/* Right Column */}
        <div className="col-md-6 mb-4 px-md-5">
          <h3 className="footer-title">Quick Links</h3>

          <div className="mb-3">
            <h5 className="quick-product">Products</h5>
            <div className="footer-links">
              <a href="/products/cement-raw-materials">Cement Raw Material Equipment</a>
              <a href="/products/raw-mill">Clinker Production Equipment</a>
              <a href="/products/cement-production">Cement Equipment & Storage</a>
              <a href="/products/cement-equipments">Conveying Equipment</a>
            </div>
          </div>



          <div>
            <h5 className="quick-product">Cement</h5>
            <div className="footer-links">
              <a href="/cement">OPC & PPC</a>
              <a href="/cement">Ready Mix Concrete</a>
            </div>
          </div>
        </div>
      </div>

      {/* Social Icons */}
      <div className="social-icons d-flex justify-content-center gap-4 my-4">
        <a href="https://wa.link/shjih2" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp"><FaWhatsapp size={28} /></a>
        <a href="https://www.facebook.com/people/Valerion-Impex-Pvt-Ltd/100082870915845/#" target="_blank" rel="noopener noreferrer" className="social-icon facebook"><FaFacebook size={28} /></a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon twitter"><FaTwitter size={28} /></a>
        <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon linkedin"><FaLinkedin size={28} /></a>
      </div>

      {/* Footer Bottom */}
      <div className="text-center border-top pt-3 pb-2">
        <small>© {new Date().getFullYear()} Valerion Impex Pvt Ltd. All rights reserved.</small>
      </div>
    </Container>
  </div>
);

export default Footer;
